import React from 'react';

const FooterQuickLinks = ({ scrollToSection }) => (
  <div>
    <h4 className="text-lg font-semibold text-gold mb-4">Quick Links</h4>
    <ul className="space-y-2">
      {[
        { id: 'home', label: 'Home' },
        { id: 'history', label: 'Temple History' },
        { id: 'deities', label: 'Deities' },
        { id: 'mahotsavam', label: 'Mahotsavam Festival' },
        { id: 'donations', label: 'Sevas and Donation' },
      ].map((link) => (
        <li key={link.id}>
          <button
            onClick={() => scrollToSection(link.id)}
            className="text-gray-300 hover:text-gold transition-colors text-left"
            data-testid={`footer-link-${link.id}`}
          >
            {link.label}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default FooterQuickLinks;
